/*
 * search query parameter from current url
 *
 * @paramName key
 * @return
 *   paramName == false: object include all params
 *   paramName != false: value for input paramName
 */
function getCurUrlParameter (paramName) {
  if (!paramName) {
    let result = {}
    if (!window) return result
    let searchString = window.location.search.substring(1)
    let params = searchString.split('&')
    for (let i = 0; i < params.length; i++) {
      let val = params[i].split('=')
      result[val[0]] = val[1]
    }
    return result
  } else {
    if (!window) return null
    let searchString = window.location.search.substring(1)
    let params = searchString.split('&')
    for (let i = 0; i < params.length; i++) {
      let val = params[i].split('=')
      if (val[0] === paramName) {
        return val[1]
      }
    }
    return null
  }
}

function flashCheck () {
  try {
    var swf = navigator.plugins['Shockwave Flash']
    if (swf === undefined) {
      return false
    } else {
      return true
    }
  } catch (e) {
    return false
  }
}

export default {
  getCurUrlParameter,
  flashCheck
}



// WEBPACK FOOTER //
// ./src/util/index.js